import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=b3354fe0&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=b3354fe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3354fe0",
  null
  
)

export default component.exports